const PRODUCT_DISPLAY_MAP = {
  'Brintellix/Lexapro': '产品A/产品D',
  Brintellix: '产品A',
  心达悦: '产品A',
  伏硫西汀: '产品A',
  Azilect: '产品B',
  安齐来: '产品B',
  雷沙吉兰: '产品B',
  Ebixa: '产品C',
  Lexapro: '产品D',
  来士普: '产品D',
  艾司西酞普兰: '产品D',
  Vyepti: '产品E',
};

const PRODUCT_ID_DISPLAY_MAP = {
  Brintellix_000001: '产品A',
  Azilect_000001: '产品B',
  Ebixa_000001: '产品C',
  Lexapro_000001: '产品D',
  Vyepti_000001: '产品E',
};

const PRODUCT_NAME_PATTERN = new RegExp(
  Object.keys(PRODUCT_DISPLAY_MAP)
    .sort((a, b) => b.length - a.length)
    .join('|'),
  'g',
);

export function displayProductName(productName, productId = '') {
  if (!productName && !productId) return '';
  const id = String(productId || '');
  const name = String(productName || '');
  return PRODUCT_ID_DISPLAY_MAP[id] || PRODUCT_DISPLAY_MAP[name] || name || id;
}

export function displayProductText(text) {
  if (text === null || text === undefined) return '';
  return String(text).replace(PRODUCT_NAME_PATTERN, (match) => PRODUCT_DISPLAY_MAP[match] || match);
}
